import { VideoElementType } from '../types';

export const generateSrc = (
  videoProps: VideoElementType,
  videoControls: boolean,
  avsSuffix: string,
  withoutCenteredButton?: boolean,
  hasDarkeningLayer?: boolean,
  isBrabusTheme?: boolean
): string => {
  const {
    mute,
    loop,
    autoPlay,
    url,
    preload = true,
    customVideoStylesBaseUrl,
    posterImageUrl,
    captionUrl
  } = videoProps;

  const paramTransform = {
    mute: mute || autoPlay ? '1' : '0',
    loop: loop ? '1' : '0',
    autoPlay: autoPlay ? '1' : '0',
    preload: preload ? '1' : '0',
    posterImageUrl,
    captionUrl
  };

  const chooseVideoStyle = () => {
    if (withoutCenteredButton) {
      if (hasDarkeningLayer) {
        return 'dmv-custom-with-controls-with-layer-without-centered-button.css';
      }
      return 'dmv-custom-with-controls-without-centered-button.css';
    }

    if (videoControls) {
      if (isBrabusTheme) {
        return 'dmv-custom-with-controls-brabus.css';
      }
      if (hasDarkeningLayer) {
        return 'dmv-custom-with-controls-with-layer.css';
      }
      return 'dmv-custom-with-controls.css';
    }

    return 'dmv-custom-without-controls.css';
  };

  const urlObj = new URL(url || 'https://smart.com');
  let withAvsSuffix;

  urlObj.pathname = urlObj.pathname.replace('/is/content/', '');

  if (urlObj.pathname.includes('.')) {
    // Splits the pathname at the last dot (of a file name).
    const pathArray = urlObj.pathname.split(/\.(?=[^.]+$)/);
    urlObj.pathname = pathArray[0];

    withAvsSuffix = `${urlObj.pathname}${avsSuffix}.${pathArray[1]}`;
  } else {
    withAvsSuffix = `${urlObj.pathname}${avsSuffix}`;
  }

  urlObj.pathname = 's7viewers/html5/VideoViewer.html';

  const params = urlObj.searchParams;

  params.set('playback', 'native');
  params.set('asset', withAvsSuffix);
  params.set('autoplay', paramTransform.autoPlay);
  params.set('loop', paramTransform.loop);
  params.set('mutevolume', paramTransform.mute);
  params.set('preload', paramTransform.preload);
  params.set('waiticon', '0');
  params.set('iconeffect', '0');
  params.set('config', 'Scene7SharedAssets/Universal_HTML5_Video');
  params.set('transition', 'fade,1.5,0.3');

  if (captionUrl) {
    params.set('caption', `${paramTransform.captionUrl},1`);
  }

  if (posterImageUrl) {
    params.set('posterimage', posterImageUrl);
  }

  params.set('style', `${customVideoStylesBaseUrl}/${chooseVideoStyle()}`);

  return urlObj.href;
};
